import React, { useState, useRef, useEffect, useMemo } from "react";
import Table from "../../Table";
import func, { translateLabel } from "../../../services/functions";
import mainAxios from "../../../services/mainAxios";
import Loader from "../../Layout/Loader";
import { useAppContext, usePersistedState } from "../../../AppContext";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import selectStyle from "../../../design/selectStyle";
import DateRange from "../../global/DateRange";
import ExportCsvPrime from "../../global/ExportCsvPrime";
import PrimeTable, { onColReorder } from "../../PrimeTable/PrimeTable";
import { Column } from "primereact/column";
import generatePaymentsReceiptColumns from "./generatePaymentsReceiptColumns";




const moment = require("moment");

const PaymentsReceipt = () => {
  const { t,i18n } = useTranslation("translations");
  const [receipts, setReceipts] = useState(null);

  const defaultExpand = {
    relatedInvoice: [],
    expandedRows: null,
    loadingRelatedInvoice: false,
    expandedInvoiceRows: [],
    expandedInvoiceData: null,
    loadingInvoiceData: false
  }
  const [expanded, setExpanded] = useState(defaultExpand)


  const {
    user: [user],
    selectedCompany: [selectedCompany],
    company: [fullCompany],
    dates: [dates, setDates],
    reloadData:[reloadData]
  } = useAppContext();

  const company = user.companiesRights.find(
    (company) => company.id === parseInt(selectedCompany)
  );

  const [loading, setLoading] = useState(false);
  const [persistedData, setPersistedData] = usePersistedState(
    null,
    "sessionData"
  );
  const [statistics, setStatistics] = useState(null);

  const businessUnitCodes = React.useMemo(() => {
    return [
      {
        label: t("invoice.businessUnitCode"),
        value: null,
      },
    ].concat(
      company.branches.map((branch) => {
        return {
          label: branch.businUnitCode + " | " + branch.sellerName,
          value: branch.businUnitCode,
        };
      })
    );
  }, [selectedCompany]);

  const filterParams = {
 

    // checkCisStatus:"false"
  };

  const defaultFilters = {
    fromDate: dates.fromDate,
    toDate: dates.toDate,
    params: {
      ...filterParams,
    },
  };
  const [filters, setFilters] = useState(defaultFilters);

  React.useEffect(() => {
    getFilteredResults(
      {
        data: { ...defaultFilters, params: { ...defaultFilters.params } },
        pageSize: 10,
        page: 1
      });
  }, [selectedCompany,reloadData]);

  const [receiptsForCsv, setReceiptsForCsv] = useState([]);
  const [tableRows, setTableRows] = useState({
    totalRows: 0,
    rowsPerPage: 10,
    currentPage: 1,
  });
  const pdfContainer = useRef();

  const getFilteredResults = (
    {
      data,
      pageSize = 10,
      page = 1,
      clearFilters = false,
      getReceiptsForCsv = false,

    }={}
  ) => {
    const requestFilters = data ? data : filters;


    let requestBody = {
      object:"PaymentReceipt",
      ...requestFilters,
      params: {
        ...requestFilters.params,
      currency:requestFilters?.params?.currency?.join(",") || null

      },
      pagination: getReceiptsForCsv
        ? null
        : {
          pageSize,
          pageNumber: page,
        },
    };

    return mainAxios
      .post(`apiEndpoint/search`, requestBody)
      .then((res) => {
       setLoading(false);
        if (res?.data?.status === true) {
            setReceipts(res.data.content)
            setTableRows((tableRows)=>({
              ...tableRows,
              totalRows: res?.data?.totalSize,
            }))
          return true;
        } 
      })
      .catch((err) => {
        setLoading(false);
        return null;
      });
  };


  const handleParamsChange = (e, label, val) => {
    const key = e ? e.target.name : label;
    const value = e ? e.target.value : val;
    setFilters((filters) => ({
      ...filters,
      params: {
        ...filters.params,
        [key]: value,
      },
    }));
  };


  let columns = generatePaymentsReceiptColumns(
    {
      t,
      i18n,
      getFilteredResults,
      tableRows,
      handleParamsChange,
      filters,
      fullCompany,
      user
    }
  );


  const [selectedColumns, setSelectedColumns] = usePersistedState(
    columns.map((col) => ({field:col.field,show:!!col.default,...(col?.persisted?{persisted:true}:{})})),
    "paymentRecieptColumns1"
  );

  const relatedInvoiceColumns =[
    {
      field: "",
      header: "",
      style: { maxWidth: 40 },
    },
    {
      field: "ublId",
      header: t(["invoice.DocNumber"]),
      style: { minWidth: 180, maxWidth: 200 },
      body:(reciept)=>{
        return <div className="d-flex gap-2">
          <div>
            {reciept.ublId}
          </div>
          <div className="badge badge-success">Default</div>
        </div>
      }

    },
    {
      field: "paymentStatus",
      header: t(["bkt.paymentStatus"]),
      style: { minWidth: 180, maxWidth: 200 },
      body:(payment)=>{
        return translateLabel(payment?.internalPaymentStatus?.engName,payment?.internalPaymentStatus?.albName,i18n)
    }

    },
    {
      field: "recordDate",
      header: "Date",
      body: (receipt) =>receipt?.issueDatetime ? moment(receipt?.issueDatetime).format("DD/MM/YYYY HH:mm"):"",
      style: { minWidth: 200, maxWidth: 300 },
      filter: true,
      filterType: "DATE",
      filterConfig: {
          like: false
      },
      sortable: true,

  },
    {
      field: "currency",
      header: t(["invoice.currency"]),
      style: { minWidth: 150, maxWidth: 180 },
    },
    {
      field: "invoiceAmount",
      header: "Invoice Amount",
      style: { minWidth: 150, maxWidth: 150 },
      body: (row) =>
        func.getFormattedMoneyValue(row?.invoiceAmount ?? 0),
      align: "right"
    },
    {
      field: "paymentAmount",
      header: "Payment Amount",
      style: { minWidth: 180, maxWidth: 180 },
      body: (row) =>
        func.getFormattedMoneyValue(row?.paymentAmount ?? 0),
      align: "right"
    },
    {
      field: "openAmount",
      header: "Open Amount",
      style: { minWidth: 150, maxWidth: 180 },
      body: (row) =>
        func.getFormattedMoneyValue(row?.openAmount ?? 0),
      align: "right"
    },

    {
      field: "reconcileDate",
      header: "Reconcile Date/Time ",
      style: { minWidth: 200, maxWidth: 250 },
      sortable: true,
    },

    {
      field: "",
      header: "",
      style: { width: 2500 },
    },

  ]




  
  const onRowCollapse = () => {
    setExpanded(defaultExpand);
  };
  const rowExpansionTemplate = () => {
    const expandedInvoiceData = expanded?.expandedInvoiceData?.data
    if (expanded?.loadingInvoiceData || expanded?.loadingRelatedInvoice) return <div style={{ width: "100vw" }}><Loader /> </div>
    return (
      <div className="d-flex flex-column ml-3 mt-3">
        {expandedInvoiceData && <div className="mb-4">
          <h4>{expanded?.expandedInvoiceData?.type == "Corrective" ? t("queue.correctedInvoice") : t("queue.correctiveInvoice")}</h4>
          <PrimeTable
            loading={expanded?.loadingInvoiceData}
            value={expandedInvoiceData ?? []}
            columns={columns}
            showFilters={false}
            paginator={false}
            filterDisplay={false}
            responsiveLayout="scroll"
            selectedColumns={[selectedColumns, setSelectedColumns]}
            showHeader={false}

          >
            <Column style={{width:40}}/>
          </PrimeTable>
        </div>}
        <div className="mb-5" style={{ width: "100vw" }}>
          <h4>{t("bkt.relatedInv")}</h4>
          <PrimeTable
            loading={expanded?.loadingRelatedInvoice}
            value={expanded.relatedInvoice}
            columns={relatedInvoiceColumns}
            showFilters={false}
            paginator={false}
            filterDisplay={false}
            responsiveLayout="scroll"
          />
        </div>

      </div>
    );
  };

  const relatedInvoiceOnExpand = (event) => {
    setExpanded((state) => ({ ...state, loadingRelatedInvoice: true, expandedRows: [event.data] }))
    mainAxios
      .post("apiEndpoint/search", {
        object: "BasicInvoice",
        params: {
          iic: event?.data?.iic?.toString(),
        },
      })
      .then((res) => {
        setExpanded(state => ({ ...state, loadingRelatedInvoice: false }))
        if (res) {
          setExpanded((state) => ({ ...state, relatedInvoice: res?.data?.content }))
        }
      })
      .catch(err => setExpanded(state => ({ ...state, loadingRelatedInvoice: false })))
  }


  const onRowExpand = (event) => {
    relatedInvoiceOnExpand(event)
  };

  return receipts ? (
    <>
      <div className="d-flex flex-wrap justify-content-between align-items-center mt-4 mb-3">
        <div className="left-header d-flex align-items-center">
          <h3 className="mb-0 p-0">{t("navbar.paymentReceipt")}</h3>
          <small className="ml-3">

            <ExportCsvPrime
              data={receiptsForCsv}
              columns={columns}
              onClick={() => getFilteredResults({ getReceiptsForCsv: true })}
              excludedColumns={["status", "actions", "print"]}
              callback={(invoice, formattedObject) => {
                formattedObject["Fisc Status"] = invoice.fiscStatus;
                formattedObject["Einvoice Status"] =
                  invoice.einvoiceStatus || "";
                formattedObject["Is Einvoice"] = invoice.einvoice
                  ? "TRUE"
                  : "FALSE";
              }}
            />
          </small>
        </div>
        <div className="mr-md-5 pr-md-4 mb-4 mb-md-0">
          <DateRange
            fromDate={filters.fromDate}
            toDate={filters.toDate}
            onChange={(dates) => {
              let fromDate = dates[0];
              let toDate = dates[1];
              if (fromDate && toDate) {
                getFilteredResults({
                  data: {
                    ...filters,
                    fromDate,
                    toDate,
                    params: { ...filters.params },
                  }
                });
              }

              setFilters((filters) => ({
                ...defaultFilters,
                fromDate,
                toDate,
              }));
              setDates({ fromDate, toDate })
              // setPersistedData({ ...persistedData, fromDate, toDate });
            }}
          />
        </div>
      </div>
      <div className="card border-0 shadow">
        <div className="card-body p-0">
          <div>
            <PrimeTable
              showFilters={true}
              reorderableColumns={true}
              filters={[filters, setFilters]}
              onFilter={(data) => {
                setFilters(data.filters);
              }}
              defaultFilters={defaultFilters}
              tableRows={[tableRows, setTableRows]}
              value={receipts}
              selectedColumns={[selectedColumns, setSelectedColumns]}
              searchableKeys={["buyerName", "ublCustomerCityName", "buyerNuis"]}
              columns={columns}
              expandedRows={expanded.expandedRows}
              onRowExpand={onRowExpand}
              onRowCollapse={onRowCollapse}
              rowExpansionTemplate={rowExpansionTemplate}
              dataKey="ublId"
              onRemoteDataChange={(remoteData) => {
                const updatedFilters = remoteData.filters ?? filters
                const updatedTableData = remoteData.tableRows ?? tableRows
                const { currentPage, rowsPerPage } = updatedTableData
                getFilteredResults({ data: updatedFilters, pageSize: rowsPerPage, page: currentPage })
              }}
              // headerButtonsLeft={headerButtonsLeft}
              onClearFilter={() => {
                getFilteredResults({ data: {...filters,params:{...defaultFilters.params}}, pageSize: 10, rowsPerPage: 1, clearFilters: true });
              }}
              onColReorder={(reorder) => onColReorder({ reorder, setSelectedColumns, childrenCount: 1 })}
              columnDeps={[expanded, fullCompany]}
              loading={loading}

            >
              <Column
                expander={() => true}
                style={{ width: "0.5em" }}
                header=""
                field="expansion"
                frozen={true}
              />
            </PrimeTable>
          </div>
        </div>
      </div>
    </>
  ) : (
    <Loader />
  );
};

export default PaymentsReceipt;
